import {widgetImplemented, WidgetType} from "../models/WidgetType";

export const WidgetImplementedPipe = "tfWidgetImplemented";

export function widgetImplementedPipe() {
    return function(type: WidgetType | null): boolean {
        if (type == null) {
            return false;
        }
        return widgetImplemented(type);
    }
}
